import { createContext, useContext } from 'react';

/**
 * Mode développeur des studios (ADR-146 addendum (15)) : réglé dans le menu ⋯ de la barre de l'éditeur, il
 * montre les noms internes (codes des valeurs d'une liste, identifiants) aux éditeurs qui en ont l'usage.
 * Désactivé par défaut : la population des studios ne voit aucun code.
 */
export const DeveloperModeContext = createContext(false);

export function useDeveloperMode(): boolean {
  return useContext(DeveloperModeContext);
}
